// Google Maps search link for a delivery address (opens the place in Maps)
export function googleMapsUrl(address) {
  const query = [address?.street, address?.city, address?.state, address?.zip].filter(Boolean).join(', ');
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
